import React, { useState, useEffect } from 'react';
import { SearchContainer, Input, ClearIcon, BackIconContainer } from './styles';
import SearchIcon from '../../assets/icons/Search';
import CloseIcon from '../../assets/icons/Close';
import BackIcon from '../../assets/icons/Back';

interface IProps {
  placeholder?: string;
  value?: string;
  onChange?: any;
  onFocus?: any;
  onBack?: any;
  inFocus?: boolean;
}

const Index = (props: IProps) => {
  const {
    placeholder = '',
    value = '',
    onChange,
    onFocus,
    onBack,
    inFocus = false,
  } = props;
  const [val, setVal] = useState(value);

  useEffect(() => {
    if (!inFocus) {
      setVal('');
    }
  }, [inFocus]);

  const handleChange = (e: any) => {
    setVal(e?.target?.value);
    onChange(e?.target?.value);
  };

  const handleFocus = () => {
    onFocus && onFocus();
  };

  const handleBack = () => {
    setVal('');
    onBack && onBack();
  };

  return (
    <SearchContainer focus={inFocus}>
      {!inFocus && <SearchIcon />}
      {inFocus && (
        <BackIconContainer onClick={handleBack}>
          <BackIcon />
        </BackIconContainer>
      )}
      <Input
        focus={inFocus}
        placeholder={placeholder}
        type={'text'}
        value={val}
        onChange={handleChange}
        onFocus={handleFocus}
      />
      {val && (
        <ClearIcon
          onClick={() => {
            setVal('');
            onChange('');
          }}
        >
          <CloseIcon />
        </ClearIcon>
      )}
    </SearchContainer>
  );
};

export default Index;
